import { useDesignMaxTheme } from "@/packages";
import { usePensionNameValue } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { type SpecialDetailProps } from "./specialDetailType.props";

export const SpecialDetail = ({ data }: SpecialDetailProps) => {
    const pensionName = usePensionNameValue();

    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();
    const { special_idx, special_name, content, title, imgList } = { ...data };
    return (
        <Center key={special_idx} position="relative" w="100%" p={isMobile ? "56px 0" : "120px 0"}>
            <Flex as="section" justifyContent="flex-end">
                <Flex overflow="hidden" maxW="1760px !important" w="100%" flexDir={isMobile ? "column-reverse" : "row"}>
                    <Flex
                        position="relative"
                        maxW="720px"
                        w="100%"
                        flexDir="column"
                        padding={isMobile ? "24px 16px" : "80px 48px"}
                        gap={isMobile ? "24px" : "32px"}
                        sx={{
                            "& p": {
                                fontFamily: "Noto Serif KR",
                                lineHeight: "140%",
                                fontWeight: "400",
                                color: "#664628",
                            },
                        }}
                    >
                        <Box w="100%">
                            <Text fontSize={isMobile ? "14px" : "24px"}>{`${pensionName}의 특별함`}</Text>
                            <Text fontSize={isMobile ? "20px" : "40px"} fontWeight="600" mt="8px">
                                {special_name.eng}
                            </Text>
                        </Box>
                        <Flex flexDir="column" minHeight={isMobile ? "auto" : "256px"} gap="16px">
                            <Text fontSize={isMobile ? "16px" : "20px"} color="#333">
                                {title.kor}
                            </Text>
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(content.kor.replace(/\r?\n/g, "<br />")),
                                }}
                                fontSize={isMobile ? "14px" : "16px"}
                                color="#6b6b6b"
                            ></Text>
                        </Flex>
                        <Text
                            w="2000px"
                            h="314px"
                            display={isLaptop ? "none" : "block"}
                            position="absolute"
                            bottom="0"
                            {...FONT("cormorant", 284, 700, 1.2)}
                            color="#fbf6f2 !important"
                        >
                            {special_name.eng}
                        </Text>
                    </Flex>
                    <Flex position="relative" maxW="1040px" w="100%">
                        <Box
                            maxW="728px"
                            minW={isMobile ? "312px" : "none"}
                            w={isMobile ? "90%" : "100%"}
                            h={isMobile ? "256px" : "960px"}
                            background={imgList[0] ? `url(${imgList[0].img_URL})no-repeat center/cover` : "gray.100"}
                            borderBottomLeftRadius={isMobile ? "40px" : "88px"}
                        />
                        <Text
                            alignSelf="flex-start"
                            color="#FBF6F2"
                            {...FONT("cormorant", isMobile ? 40 : 104, 700, 1.2)}
                            sx={{
                                writingMode: "vertical-rl",
                            }}
                        >
                            SPECIAL
                        </Text>
                        {imgList[1] && (
                            <Box
                                display={isMobile ? "none" : "block"}
                                position="absolute"
                                right="0"
                                bottom="0"
                                pb="64px"
                            >
                                <Box
                                    w="540px"
                                    h="428px"
                                    background={
                                        imgList[1] ? `url(${imgList[1].img_URL})no-repeat center/cover` : "none"
                                    }
                                    borderTopLeftRadius="88px"
                                />
                            </Box>
                        )}
                    </Flex>
                </Flex>
            </Flex>
        </Center>
    );
};
